import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LoadingComponent } from "../../../../../components/common/loading/loading.component";
import { ComparisonCardComponent } from "../../../../../components/comparison-card/comparison-card.component";
import { SharedComponents } from "../../../../../components/shared.module";
import { TcoTableComponent } from "../../../../../components/tco-table/tco-table.component";
import { ConfigService } from "../../../../../core/services/config/config.service";
import { RestTcoService } from "../../../../../core/services/rest-tco.service";
import { TcoProjectService } from "../../../../../core/services/tco-project/tco-project.service";
import { UtilitiesService } from "../../../../../core/services/utilities.service";
import { MaterialModule } from "../../../../../core/shared/material.module";

@Component({
  selector: "app-potential-overlap-test-cases",
  standalone: true,
  imports: [
    CommonModule,
    ComparisonCardComponent,
    FormsModule,
    TcoTableComponent,
    SharedComponents,
    MaterialModule,
    LoadingComponent
  ],
  templateUrl: "./potential-overlap-test-cases.component.html",
  styleUrl: "./potential-overlap-test-cases.component.scss",
})
export class PotentialOverlapTestCasesComponent implements OnInit {
  @Input() modelId: any;
  @Output() moveToPreviousTabEvent = new EventEmitter<void>();
  
  isLoading = false;
  testArray: any[] = [];
  segmentData: any[] = [];
  filteredTestArray: any[] = [];
  selectedClusterId: string | null = null;
  testDescriptionSimilarity: any;
  expResultsSimilarity: any;
  overlappingResult: any;
  overlappingConfidence: any;
  testIdsForSelectedCluster: any;
  selectedClusterTopKeywords: string | null = null;
  baseTestCase: any = {};
  comparedTestCase: any = {};
  overlappingOriginalData: any[] = [];

  data: any = [
    {
      id: "TC_SBDSN",
      steps: [
        "ishajkasd",
        "asdjkbjasdsadasd",
        "sakdjbjkasdas",
        "askdjbkjasdjkkjvasdh",
      ],
      results: [
        "ishajkasd",
        "asdjkbjasdsadasd",
        "sakdjbjkasdas",
        "askdjbkjasdjkkjvasdh",
      ],
    },
    {
      id: "TC_SBDSN",
      steps: [
        "ishajkasd",
        "asdjkbjasdsadasd",
        "sakdjbjkasdas",
        "askdjbkjasdjkkjvasdh",
      ],
      results: [
        "ishajkasd",
        "asdjkbjasdsadasd",
        "sakdjbjkasdas",
        "askdjbkjasdjkkjvasdh",
      ],
    },
    {
      id: "TC_SBDSN",
      steps: [
        "ishajkasd",
        "asdjkbjasdsadasd",
        "sakdjbjkasdas",
        "askdjbkjasdjkkjvasdh",
      ],
      results: [
        "ishajkasd",
        "asdjkbjasdsadasd",
        "sakdjbjkasdas",
        "askdjbkjasdjkkjvasdh",
      ],
    },
    {
      id: "TC_SBDSN",
      steps: [
        "ishajkasd",
        "asdjkbjasdsadasd",
        "sakdjbjkasdas",
        "askdjbkjasdjkkjvasdh",
      ],
      results: [
        "ishajkasd",
        "asdjkbjasdsadasd",
        "sakdjbjkasdas",
        "askdjbkjasdjkkjvasdh",
      ],
    },
  ];

  colors: any = [
    {
      bg: "rgba(47, 118, 255, 0.05)",
      border: "rgba(47, 118, 255, 1)",
    },
    {
      bg: "rgba(168, 37, 219, 0.05)",
      border: "rgba(168, 37, 219, 1)",
    },
  ];
  extractedRealm: string | null;

  percentages: any = {
    current: 84.12,
    expected: 60.25
  };

  getColor(ind: number) {
    let targetInd = ind % 2;
    return this.colors[targetInd];
  }

  constructor(
    private restTcoService: RestTcoService,
    private tcoProjectService: TcoProjectService,
    private configService: ConfigService,
    private utilityService: UtilitiesService
  ) {
    this.tcoProjectService.getModalId().subscribe((id) => {
      this.modelId = id;
    });
    this.extractedRealm = this.configService.getConfig("isDomainResolver")
      ? this.utilityService?.extractRealmFromUrl()
      : sessionStorage.getItem("selectedRealm");
  }

  ngOnInit(): void {
    this.getdata();
  }

  getdata() {
    if (this.modelId) {
      this.isLoading = true;
      this.restTcoService
        .getAllOverlapTestcasesByModelId(this.modelId)
        .subscribe((response) => {
          this.testArray = response;
          console.log("Testcase data", this.testArray);
          if (this.modelId) {
            this.restTcoService
              .getAllSegmentationDataByModelId(this.modelId)
              .subscribe((response) => {
                this.segmentData = response;
                this.isLoading = false;
                // Modify segmentData to include formattedCorStepDesc
                this.segmentData = this.segmentData.map((segment) => {
                  const formattedSteps = this.formatSteps(segment.corStepDesc);
                  return { ...segment, formattedCorStepDesc: formattedSteps };
                });
                if (this.testArray.length > 0) {
                  this.testArray[0].select = true;
                  this.onRowCheckboxChange(this.testArray[0]);
                }
                this.overlappingTestcasesData();
              });
          }
        });
    }
  }

  formatSteps(description: string): string[] {
    if (!description.startsWith("Step")) {
      return [description];
    }

    const steps = description.split("Step");
    steps.shift(); // Remove the empty first element

    const formattedSteps = steps.map((step) => {
      const lines = step.split(/\n/);
      const formattedSubSteps = lines.map((line, index) => {
        if (index === 0) {
          return `Step ${line.trim()}`;
        } else {
          return `\t${line.trim()}`;
        }
      });
      return formattedSubSteps.join("\n");
    });

    return formattedSteps;
  }

  handleRowSelection(event: any): void {
    const selectedTestCases: any[] = event.list;
    console.log('Selected Rows:', selectedTestCases);
    if(selectedTestCases.length > 0) {
      this.onRowCheckboxChange(selectedTestCases[0]);
    }
  }
  
  onRowCheckboxChange(item: any) {
    this.selectedClusterId = item.clusterId;

    this.testArray.forEach((item) => {
      if (item.clusterId != this.selectedClusterId) {
        item.checked = false;
      }
    });

    this.testDescriptionSimilarity = item.stepDescScore;
    this.expResultsSimilarity = item.expResultScore;
    this.overlappingResult = "";
    this.overlappingConfidence = "";

    //Selected cluster Testcases
    if (this.selectedClusterId) {
      this.testIdsForSelectedCluster = this.testArray
        .filter((testCase) => testCase.clusterId === this.selectedClusterId)
        .map((testCase) => JSON.parse(testCase.testId));
      console.log("TestId In Cluster", this.testIdsForSelectedCluster);

      const foundSelectedCluster = this.testArray.find(
        (item) => item.clusterId === this.selectedClusterId
      );
      if (foundSelectedCluster) {
        this.selectedClusterTopKeywords = foundSelectedCluster.topKeywords;
        console.log(
          "selectedClusterKeywords :",
          this.selectedClusterTopKeywords
        );
      }
    } else {
      this.testIdsForSelectedCluster = [];
    }

    this.filteredTestArray = [];
    this.filterTestArray();
  }

  filterTestArray() {
    this.filteredTestArray = [];
    this.baseTestCase = {};
    this.comparedTestCase = {};

    // Loop through the testIds in the selected cluster
    this.testIdsForSelectedCluster[0].forEach((selectedTestId: number) => {
      const matchingSegment = this.segmentData.find(
        (segment) => parseInt(segment.testId) === selectedTestId
      );

      if (matchingSegment) {
        const filteredSegment = { ...matchingSegment };
        this.filteredTestArray.push(filteredSegment);
      }
    });

    // Update baseTestCase and comparedTestCase accordingly
    this.baseTestCase = this.filteredTestArray[0] || {};
    this.comparedTestCase = this.filteredTestArray[1] || {};
  }

  overlappingTestcasesData() {
    const overlapppingTestIds = this.testArray.map((testCase) =>
      JSON.parse(testCase.testId)
    );
    console.log(" IN Overlapping", overlapppingTestIds);

    const concatenatedArray = [].concat(...overlapppingTestIds);

    const uniqueArray = [...new Set(concatenatedArray)];
    console.log("Test Ids", uniqueArray);

    uniqueArray.forEach((selectedTestId: number) => {
      const matchingSegment = this.segmentData.find(
        (segment) => parseInt(segment.testId) === selectedTestId
      );

      if (matchingSegment) {
        const filteredSegment = { ...matchingSegment };
        this.overlappingOriginalData.push(filteredSegment);
      }
    });
    console.log("Overlapping DATA :", this.overlappingOriginalData);
  }


highlightStepDifferencesX(sentence: string, testcaseType: string): number {
  if (!sentence) {
      return -1; 
  }

  const stepContent = sentence.split(':')[1]?.trim()?.toLowerCase();
  const stepNumber = sentence.split(':')[0]?.trim();

  if (!stepContent || !stepNumber) {
      return -1; 
  }

  let compareWith: any;
  if (testcaseType === 'base') {
      compareWith = this.comparedTestCase;
  } else if (testcaseType === 'compare') {
      compareWith = this.baseTestCase;
  }

  const formattedStepDesc = compareWith.formattedCorStepDesc;
  for (let i = 0; i < formattedStepDesc.length; i++) {
    const stepDescNumberMatch = formattedStepDesc[i].match(/Step (\d+)/); // Match "Step" followed by one or more digits
    const stepDescNumberOnly = stepDescNumberMatch ? parseInt(stepDescNumberMatch[1]) : null; // Extract the numeric part
      const stepDescNumber = formattedStepDesc[i].split(':')[0]?.trim();
      const stepDescContent = formattedStepDesc[i].split(':')[1]?.trim()?.toLowerCase();;
      if (stepDescContent && stepDescNumber && stepContent === stepDescContent && stepNumber !== stepDescNumber) {
          return Number(stepDescNumberOnly); 
      }
  }
  return -1; 
}

isStepNumber(word: string, index: number): boolean {
  if(index == 1){
    console.log("Index", index,word)
    return !isNaN(parseInt(word.trim()));
  }
  return false;
}

highlightFormattedStepDesc(stepDescWord: any, wordIndex: number, lineIndex: number, testcaseType: string): boolean {
  let compareWith: any;
  if(testcaseType == 'base'){
    compareWith = this.comparedTestCase;
  }else if(testcaseType == 'compare'){
    compareWith = this.baseTestCase
  }

  const compareToSentence = compareWith.formattedCorStepDesc[lineIndex];
  if(!compareToSentence)
    return true;

  

  if (compareWith && compareWith.formattedCorStepDesc && lineIndex != null && lineIndex < compareWith.formattedCorStepDesc.length) {
    const testNameWords = compareWith.formattedCorStepDesc[lineIndex].split(' ');
    const lowercaseTestNameWords = testNameWords.map((word: string) => word.toLowerCase());
    const lowercaseStepDescWord = stepDescWord.toLowerCase();

    if (lowercaseTestNameWords[wordIndex] !== lowercaseStepDescWord) {
      return true;
    }

   
  }
  return false;
}


highlightStepDifferences(sentence: string, testcaseType: string): boolean {
  if (!sentence) {
      return false; 
  }

  const stepContent = sentence.split(':')[1]?.trim()?.toLowerCase(); 
  const stepNumber = sentence.split(':')[0]?.trim(); 

  if (!stepContent || !stepNumber) {
      return false; 
  }

  let compareWith: any;
  if (testcaseType === 'base') {
      compareWith = this.comparedTestCase;
  } else if (testcaseType === 'compare') {
      compareWith = this.baseTestCase;
  }

  const formattedStepDesc = compareWith.formattedCorStepDesc;
  for (const stepDesc of formattedStepDesc) {
      const stepDescNumber = stepDesc.split(':')[0]?.trim(); 
      const stepDescContent = stepDesc.split(':')[1]?.trim()?.toLowerCase(); 
      if (stepDescContent && stepDescNumber && stepContent === stepDescContent && stepNumber !== stepDescNumber) {
          return true; 
      }
  }
  return false; 
}

highlightExpectedResults(testDescription: any, wordIndex: number, testcaseType: string): boolean {
  let compareWith: any;
  if(testcaseType == 'base'){
    compareWith = this.comparedTestCase;
  }else if(testcaseType == 'compare'){
    compareWith = this.baseTestCase
  }
  const testNameWords = compareWith.cleanedExpResult.split(' ');
  if (testNameWords[wordIndex] !== testDescription) {
    return true;
  }
  return false;
}
  onRowSelect(data: any) {
    console.log('row', data);
  }
 
goBack() {
  this.moveToPreviousTabEvent.emit();
}
}
